export {
	ModalBody,
	ModalClose,
	ModalDescription,
	ModalFooter,
	ModalFooterTemplate,
	ModalHeader,
	ModalHeaderTemplate,
	ModalTitle,
	ModalTrigger,
} from "ics-ui-kit/components/modal";

export { ModalContent } from "./ModalContent";

export { isFromModal } from "./utils";
